import { z } from 'zod';

export const PaymentIntentSchema = z.object({
  amount: z.number().int().positive('Amount must be positive'),
  currency: z.string().length(3).optional().default('eur'),
  metadata: z.record(z.string(), z.string()).optional().default({}),
});

export const CreateCustomerSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  email: z.string().email('Invalid email address'),
  metadata: z.record(z.string(), z.string()).optional().default({}),
});

export const CreateSubscriptionSchema = z.object({
  customerId: z.string().min(1, 'Customer ID is required'),
  priceId: z.string().min(1, 'Price ID is required'),
  metadata: z.record(z.string(), z.string()).optional().default({}),
});

export type PaymentIntentDto = z.infer<typeof PaymentIntentSchema>;
export type CreateCustomerDto = z.infer<typeof CreateCustomerSchema>;
export type CreateSubscriptionDto = z.infer<typeof CreateSubscriptionSchema>;

export const validatePaymentIntent = (data: unknown) => {
  return PaymentIntentSchema.safeParse(data);
};

export const validateCreateCustomer = (data: unknown) => {
  return CreateCustomerSchema.safeParse(data);
};

export const validateCreateSubscription = (data: unknown) => {
  return CreateSubscriptionSchema.safeParse(data);
};
